"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneDynamicCodeCheckRequest = void 0;
var PhoneDynamicCodeCheckRequest = /** @class */ (function () {
    function PhoneDynamicCodeCheckRequest() {
    }
    return PhoneDynamicCodeCheckRequest;
}());
exports.PhoneDynamicCodeCheckRequest = PhoneDynamicCodeCheckRequest;
;
//# sourceMappingURL=phoneDynamicCodeCheck.request.js.map